import { render, staticRenderFns } from "./WSwitch.vue?vue&type=template&id=04db3d84&scoped=true"
import script from "./WSwitch.vue?vue&type=script&lang=js"
export * from "./WSwitch.vue?vue&type=script&lang=js"
import style0 from "./WSwitch.vue?vue&type=style&index=0&id=04db3d84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04db3d84",
  null
  
)

export default component.exports